var map = {
	"./airbnb.svg": 1029,
	"./apple.svg": 1041,
	"./discord.svg": 1209,
	"./dropbox.svg": 6331,
	"./figma.svg": 4789,
	"./github.svg": 1010,
	"./google.svg": 1326,
	"./indeed.svg": 7276,
	"./intel.svg": 889,
	"./line.svg": 1337,
	"./linux.svg": 6163,
	"./meta.svg": 8876,
	"./netflix.svg": 7557,
	"./paypal.svg": 902,
	"./pinterest.svg": 9911,
	"./reddit.svg": 363,
	"./shopify.svg": 847,
	"./snapchat.svg": 7997,
	"./spotify.svg": 5099,
	"./tiktok.svg": 4309,
	"./uber.svg": 4807,
	"./whatsapp.svg": 8257,
	"./wordpress.svg": 1584,
	"./x.svg": 4985,
	"./youtube.svg": 2758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1851;